/* eslint-disable */

import type { SettingsLang } from "./types/SettingsLang";

let data: SettingsLang | undefined;

export type { SettingsLang };

export default function SettingsLangFactory(): SettingsLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setSettingsLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/SettingsLangDef").then(({ SettingsLangDef }) => {
      data = SettingsLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/SettingsLangDef").then(({ SettingsLangDef }) => {
      data = SettingsLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/SettingsLangDef").then(({ SettingsLangDef }) => {
      data = SettingsLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/SettingsLangDef").then(({ SettingsLangDef }) => {
      data = SettingsLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

